"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const oxygen_text_link_1 = __importDefault(require("@8x8/oxygen-text-link"));
const oxygen_config_1 = require("@8x8/oxygen-config");
const ActionsContainer_1 = require("../styled/ActionsContainer");
const Actions = ({ actions, theme }) => (react_1.default.createElement(ActionsContainer_1.ActionsContainer, null, actions.map(({ id, title, callback }) => (react_1.default.createElement(oxygen_text_link_1.default, { onClick: callback, key: id, theme: theme.textLinkAsAction, color: theme.isClassic ? 'inherit' : 'primary', underline: theme.isClassic ? 'always' : 'never', ...(0, oxygen_config_1.getTestAttributes)('TOAST_ACTION') }, title)))));
exports.default = Actions;
